import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { CSVDownload } from "react-csv";
import { Table, Icon, Spin } from 'antd';
import { TitleText, BasicText, ShortInput, LongInput, CopyUrl, BasicButton } from '@components';
import { ConfirmModal } from '@components';
import { getEmailsForDownload } from '@actions';

const DownloadEmails = ({
  getEmailsForDownload
}) => {
  const [showDownloadConfirm, setShowDownloadConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadEmails, setDownloadEmails] = useState(null);

  const button = () => {
    return (
      <BasicButton
        text="Download Emails"
        type="primary"
        fontSize={10}
        style={{ padding: 8 }}
        onClick={() => setShowDownloadConfirm(true)}
      />
    );
  }

  const createDownloadList = (emailList) => {
    const results = [];
    emailList.forEach((u) => {
      results.push({
        full_name: u.full_name,
        username: u.username,
        email: u.email
      });
    })
    setDownloadEmails(results);
    setIsLoading(false);
    setShowDownloadConfirm(false);
  }

  const onDownload = () => {
    setIsLoading(true);
    getEmailsForDownload(
      (emails) => {
        createDownloadList(emails);
      },
      (error) => console.log(error)
    );
  };

  return (
    <>
      {button()}

      {showDownloadConfirm &&
        <ConfirmModal
          title={"Confirm Download"}
          visible={showDownloadConfirm}
          loading={isLoading}
          onCancel={() => setShowDownloadConfirm(false)}
          onSubmit={() => onDownload()}
        >
          <BasicText marginBottom="20px">
            Are you sure you want to download all users emails?
          </BasicText>
        </ConfirmModal>
      }

      {downloadEmails != null && <CSVDownload data={downloadEmails} target="_blank" />}
    </>
  );
};

export default connect(null, {
  getEmailsForDownload
})(DownloadEmails);
